import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e6f979c8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=e6f979c8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f979c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6f979c8')) {
      api.createRecord('e6f979c8', component.options)
    } else {
      api.reload('e6f979c8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e6f979c8&scoped=true", function () {
      api.rerender('e6f979c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/internal/components/LogisticsTable/index.vue"
export default component.exports